import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'leaflet/dist/leaflet.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><App /></React.StrictMode>
);

// ── Capture install prompt BEFORE browser hides it ──────────
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e; // store globally for React to access
  window.dispatchEvent(new Event('pwaInstallAvailable'));
});

// ── Track successful install ─────────────────────────────────
window.addEventListener('appinstalled', () => {
  window.__pwaInstallPrompt = null;
  window.dispatchEvent(new Event('pwaInstalled'));
  console.log('[PWA] App installed successfully');
});

// ── Register service worker (production only) ────────────────
if ('serviceWorker' in navigator && window.location.hostname !== 'localhost') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      console.log('SW registered:', reg.scope);
      setInterval(() => reg.update(), 60000);

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            showUpdateBanner();
          }
        });
      });
    }).catch(err => console.log('SW failed:', err));

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  });
}

function showUpdateBanner() {
  const existing = document.getElementById('zz-update-banner');
  if (existing) existing.remove();

  const banner = document.createElement('div');
  banner.id = 'zz-update-banner';
  banner.innerHTML = `
    <div style="position:fixed;bottom:80px;left:12px;right:12px;z-index:9999;background:#1A6B3C;color:white;border-radius:12px;padding:12px 16px;display:flex;align-items:center;gap:12px;box-shadow:0 4px 20px rgba(0,0,0,.25);">
      <span style="font-size:22px">🚀</span>
      <div style="flex:1">
        <div style="font-size:13px;font-weight:700">New update available!</div>
        <div style="font-size:11px;opacity:.85;margin-top:1px">Tap Update to get latest features</div>
      </div>
      <button id="zz-do-update" style="background:white;color:#1A6B3C;border:none;border-radius:8px;padding:6px 14px;font-size:12px;font-weight:700;cursor:pointer;">Update</button>
      <button id="zz-later" style="background:rgba(255,255,255,.2);color:white;border:none;border-radius:6px;padding:6px 10px;font-size:12px;cursor:pointer;">Later</button>
    </div>
  `;
  document.body.appendChild(banner);

  document.getElementById('zz-do-update').onclick = () => {
    banner.remove();
    navigator.serviceWorker.getRegistration().then(reg => {
      if (reg && reg.waiting) reg.waiting.postMessage({ type:'SKIP_WAITING' });
    });
  };
  document.getElementById('zz-later').onclick = () => banner.remove();
  setTimeout(() => banner && banner.remove(), 30000);
}